// extracted by mini-css-extract-plugin
export default {"upload-method":"uploadMethod_upload-method__l1aeb"};